export default defineNuxtRouteMiddleware(async (to) => {
  const authStore = useAuthStore();
  const { user, isAuthenticated } = storeToRefs(authStore);

  if (!isAuthenticated.value) return navigateTo({ name: 'login' });

  const hasCompany = Boolean(user.value?.companyId);
  const needsOnboardingGate = to.path.startsWith('/chats') || to.path.startsWith('/agents');

  // If user navigates to wizard but already has a company, send them to agents
  if (to.path === '/wizard' && hasCompany) {
    return navigateTo('/agents');
  }

  // If no company and accessing gated routes, force wizard route
  if (!hasCompany && needsOnboardingGate) {
    return navigateTo('/wizard');
  }
});
